<div [hidden]="!isOpen">
    <dcp-content-loading-indicator *ngIf="!isPaymentElementLoaded && !errorMessage"></dcp-content-loading-indicator>
    <div class="card-errors mt-2" *ngIf="!isPaymentElementLoaded && errorMessage">
        {{ errorMessage }}
    </div>

    <form #ccForm name="ccForm" [ngClass]="{ 'd-none': !isPaymentElementLoaded }" class="cybersource-form" (ngSubmit)="submitCreditCard()">
        <div class="number">
            <label>Card number</label>
            <div id="number-container" class="d-flex form-control"
                 [ngStyle]="{'background-image': getCardImageAsBackground()}"
                 [class.invalidInput]="!!errorMessages.ccNumber.text"
            >
            </div>
            <div class="input-error-message">{{ errorMessages.ccNumber.text }}</div>
        </div>
        <div class="expiration">
            <label>Expiration</label>
            <div id="expiration-date" class="form-control">
                <input #expirationDateInput type="text" maxlength="5" placeholder="MM / YY" name="expirationDate"
                       [class.invalidInput]="!!errorMessages.expirationDate.text"
                       [(ngModel)]="expirationDate"
                       (ngModelChange)="expirationDateUpdate($event)"
                       (keydown.backspace)="handleBackSpace($event)"
                       (blur)="errorMessages.expirationDate.show = true; validateExpirationDate()"
                />
            </div>
            <div class="input-error-message">{{ errorMessages.expirationDate.text }}</div>
        </div>
        <div class="cvc">
            <label>CVC</label>
            <div id="securityCode-container" [class.invalidInput]="!!errorMessages.securityCode.text" class="form-control"></div>
            <div class="input-error-message">{{ errorMessages.securityCode.text }}</div>
        </div>
    </form>

    <ng-container *ngIf="isPaymentElementLoaded">
        <div class="mt-3">
            <button type="button"
                    class="ds-button ds-button--primary me-4 focusable focusable__element"
                    data-cy="stripe-save-cc-button"
                    [disabled]="isSaveCardInProgress || !isFormComplete()"
                    (click)="submitCreditCard()">
                <div *ngIf="isSaveCardInProgress" aria-hidden="true" class="spinner-border mr-3" role="status"></div>
                {{ 'common.save' | cxTranslate }}
            </button>
            <button *ngIf='isClosable' type="button"
                    class="ds-button ds-button--secondary me-4 focusable focusable__element"
                    data-cy="stripe-close-btn"
                    [disabled]="isSaveCardInProgress"
                    (click)="close()">{{ 'common.cancel' | cxTranslate }}</button>
        </div>
        <div class="card-errors mt-2" *ngIf="errorMessage">
            {{ errorMessage }}
        </div>

        <div class="info-message">
            {{ infoMessage }}
        </div>
        <hr>
    </ng-container>

    <dcp-cyber-source-device-data-collection-form [deviceDataCollectionSetup]="deviceDataCollectionSetup"></dcp-cyber-source-device-data-collection-form>
</div>

